import styled from 'styled-components'

export const ContentExpand = styled.div`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
`
